<template>
  <div
    :class="{ 'is-hidden': !hasSuggestions }"
    class="c-header-search__block -lateral-padded"
  >
    <div class="o-grid -vertical-gutter -xs-gutter-small">
      <div
        v-for="(suggestedSearch, index) in suggestedSearches.products"
        :key="`product-search-${index}`"
        class="c-header-search__block-suggestion"
      >
        <!-- eslint-disable vue/no-v-html -->
        <button
          type="button"
          class="o-text -xs-extra-dark -xs-medium -xs-long-primer t-text-left"
          @click="chooseSuggestedSearch(suggestedSearch, productsSearchContext)"
          v-html="getHighlightedSuggestedSearchHtml(suggestedSearch.text)"
        />
        <!-- eslint-enable -->
      </div>

      <div
        v-for="(suggestedSearch, index) in suggestedSearches.sellers"
        :key="`store-search-${index}`"
        class="c-header-search__block-suggestion-seller"
      >
        <a
          class="c-header-search__block-suggestion-seller-avatar-image"
          :href="suggestedSearch.url"
        >
          <img
            class="c-header-search__block-suggestion-seller-avatar-image"
            :alt="`Imagem da lojinha ${suggestedSearch.text}`"
            :src="
              suggestedSearch.image
                | enjuphotosUrl(enjuphotos.presets.userStore.avatar)
            "
          >
        </a>

        <!-- eslint-disable vue/no-v-html -->
        <button
          type="button"
          class="o-text -xs-extra-dark -xs-medium -xs-long-primer t-text-left"
          @click="chooseSuggestedSearch(suggestedSearch, productsSearchFromStoreContext)"
          v-html="getHighlightedSuggestedSearchHtml(suggestedSearch.text)"
        />
        <!-- eslint-enable -->
      </div>
    </div>
  </div>
</template>

<script>
  import debounce from 'debounce'
  import '@/tools/filters/enjuphotos-url'

  import axios from '@/tools/axios/axios'
  import { PRODUCTS_SEARCH_CONTEXT, STORES_SEARCH_CONTEXT } from '@/tools/constants/contexts-for-metrics'
  import { ENJUPHOTOS_PRESETS } from '@/tools/enjuphotos'

  import SearchAutocompleteService from '@/web/services/search-autocomplete'

  const MAX_SUGGESTIONS = 5
  const FETCH_SUGGESTIONS_DEBOUNCE_DURATION = 200
  const TERM_MIN_LENGTH_TO_FETCH_SUGGESTIONS = 1

  export default {
    props: {
      term: {
        required: true,
        type: String
      },
      context: {
        required: true,
        type: String
      }
    },
    data() {
      return {
        enjuphotos: {
          presets: ENJUPHOTOS_PRESETS
        },
        suggestedSearches: {
          products: [],
          sellers: []
        },
        searchAutocompleteService: new SearchAutocompleteService(process.env.SERVICE_HUB_ENJUSEARCH),
        productsSearchContext: PRODUCTS_SEARCH_CONTEXT.PRODUCTS_SEARCH,
        productsSearchFromStoreContext: STORES_SEARCH_CONTEXT.STORE_VIEWED
      }
    },
    computed: {
      hasSuggestions() {
        return this.suggestedSearches.products.length || this.suggestedSearches.sellers.length
      }
    },
    watch: {
      term: {
        immediate: true,
        handler() {
          this.handleInputChange()
        }
      },
      context: {
        handler() {
          this.handleInputChange()
        }
      }
    },
    methods: {
      getHighlightedSuggestedSearchHtml(text) {
        return text.replace(
          new RegExp(`(${this.term.replace(/<[^>]*>?/gm, '')})`, 'i'),
          '<span class="o-text -xs-bold ">$1</span>'
        )
      },
      chooseSuggestedSearch(suggestedSearch, context) {
        this.$emit('choose-term', suggestedSearch, context)
      },
      handleInputChange() {
        this.suggestedSearches.products = []
        this.suggestedSearches.sellers = []

        if (this.term.length >= TERM_MIN_LENGTH_TO_FETCH_SUGGESTIONS)
          this.scheduleFetchSearchSuggestions()
      },
      fetchSuggestions() {
        const options = {
          variables: { term: this.term.toString() },
          context: this.context
        }

        return this.searchAutocompleteService.fetch(options)
          .then(response => {
            this.lastRequestCancelSource = null
            return response
          })
      },
      scheduleFetchSearchSuggestions: debounce(function() {
        this.fetchSuggestions()
          .then((response) => {
            if (!response.data.autocomplete) {
              return
            }

            const context = Object.keys(response.data.autocomplete)[0]
            this.suggestedSearches[context] = response.data.autocomplete[context].slice(0, MAX_SUGGESTIONS)
          })
          .catch(error => {
            if (
              ['Query missing', 'Context missing'].indexOf(error.message) === -1 &&
              !axios.isCancel(error)
            ) {
              throw error
            }
          })
      }, FETCH_SUGGESTIONS_DEBOUNCE_DURATION)
    }
  }
</script>
